/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { FileUploadResponseV1 } from '../models/file-upload-response-v-1';


/**
 * API for store and retrieve request files.
 */
@Injectable({
  providedIn: 'root',
})
export class FilesV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation uploadRequestQuestionFiles
   */
  static readonly UploadRequestQuestionFilesPath = '/v1/files/supplier-request/{requestId}/{questionId}/files';

  /**
   * Upload request case files scoped to a question.
   *
   * Uploads files to a question-scoped blob path (requestId/questionId/filename) and returns validated filenames, preserving the original characters (including non-Latin scripts). Same filename uploaded to the same question overwrites.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadRequestQuestionFiles()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadRequestQuestionFiles$Response(params: {
    requestId: string;
    questionId: string;
    body?: {

/**
 * Array of files to upload
 */
'files': Array<Blob>;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FileUploadResponseV1>> {

    const rb = new RequestBuilder(this.rootUrl, FilesV1Service.UploadRequestQuestionFilesPath, 'post');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.path('questionId', params.questionId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileUploadResponseV1>;
      })
    );
  }

  /**
   * Upload request case files scoped to a question.
   *
   * Uploads files to a question-scoped blob path (requestId/questionId/filename) and returns validated filenames, preserving the original characters (including non-Latin scripts). Same filename uploaded to the same question overwrites.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadRequestQuestionFiles$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadRequestQuestionFiles(params: {
    requestId: string;
    questionId: string;
    body?: {

/**
 * Array of files to upload
 */
'files': Array<Blob>;
}
  },
  context?: HttpContext

): Observable<FileUploadResponseV1> {

    return this.uploadRequestQuestionFiles$Response(params,context).pipe(
      map((r: StrictHttpResponse<FileUploadResponseV1>) => r.body as FileUploadResponseV1)
    );
  }

  /**
   * Path part for operation deleteRequestQuestionFiles
   */
  static readonly DeleteRequestQuestionFilesPath = '/v1/files/supplier-request/{requestId}/{questionId}/files';

  /**
   * Delete request case files scoped to a question.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRequestQuestionFiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteRequestQuestionFiles$Response(params: {
    requestId: string;
    questionId: string;

    /**
     * List of files to be removed
     */
    fileNames?: any;
    body: Array<string>
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, FilesV1Service.DeleteRequestQuestionFilesPath, 'delete');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.path('questionId', params.questionId, {});
      rb.query('fileNames', params.fileNames, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete request case files scoped to a question.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRequestQuestionFiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteRequestQuestionFiles(params: {
    requestId: string;
    questionId: string;

    /**
     * List of files to be removed
     */
    fileNames?: any;
    body: Array<string>
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteRequestQuestionFiles$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation uploadRequestFiles
   */
  static readonly UploadRequestFilesPath = '/v1/files/supplier-request/{requestId}/files';

  /**
   * Upload request case files.
   *
   * Deprecated - use the question-scoped upload endpoint instead. Uploads files to blob storage and returns validated filenames, preserving the original characters (including non-Latin scripts). Use the download-url endpoint to retrieve SAS URLs when needed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadRequestFiles()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   *
   * @deprecated
   */
  uploadRequestFiles$Response(params: {
    requestId: string;
    body?: {

/**
 * Array of files to upload
 */
'files': Array<Blob>;
}
  },
  context?: HttpContext

): Observable<StrictHttpResponse<FileUploadResponseV1>> {

    const rb = new RequestBuilder(this.rootUrl, FilesV1Service.UploadRequestFilesPath, 'post');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileUploadResponseV1>;
      })
    );
  }

  /**
   * Upload request case files.
   *
   * Deprecated - use the question-scoped upload endpoint instead. Uploads files to blob storage and returns validated filenames, preserving the original characters (including non-Latin scripts). Use the download-url endpoint to retrieve SAS URLs when needed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadRequestFiles$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   *
   * @deprecated
   */
  uploadRequestFiles(params: {
    requestId: string;
    body?: {

/**
 * Array of files to upload
 */
'files': Array<Blob>;
}
  },
  context?: HttpContext

): Observable<FileUploadResponseV1> {

    return this.uploadRequestFiles$Response(params,context).pipe(
      map((r: StrictHttpResponse<FileUploadResponseV1>) => r.body as FileUploadResponseV1)
    );
  }

  /**
   * Path part for operation deleteRequestFiles
   */
  static readonly DeleteRequestFilesPath = '/v1/files/supplier-request/{requestId}/files';

  /**
   * Delete request case files.
   *
   * Deprecated - use the question-scoped delete endpoint instead.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteRequestFiles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  deleteRequestFiles$Response(params: {
    requestId: string;

    /**
     * List of files to be removed
     */
    fileNames?: any;
    body: Array<string>
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, FilesV1Service.DeleteRequestFilesPath, 'delete');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.query('fileNames', params.fileNames, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete request case files.
   *
   * Deprecated - use the question-scoped delete endpoint instead.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteRequestFiles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   *
   * @deprecated
   */
  deleteRequestFiles(params: {
    requestId: string;

    /**
     * List of files to be removed
     */
    fileNames?: any;
    body: Array<string>
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteRequestFiles$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getRequestQuestionFile
   */
  static readonly GetRequestQuestionFilePath = '/v1/files/supplier-request/{requestId}/{questionId}/files/{fileName}';

  /**
   * Download request case file scoped to a question.
   *
   * Falls back to the legacy requestId/filename path for files uploaded before the question-scoped storage path was introduced.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRequestQuestionFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRequestQuestionFile$Response(params: {
    requestId: string;
    questionId: string;
    fileName: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, FilesV1Service.GetRequestQuestionFilePath, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.path('questionId', params.questionId, {});
      rb.path('fileName', params.fileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Download request case file scoped to a question.
   *
   * Falls back to the legacy requestId/filename path for files uploaded before the question-scoped storage path was introduced.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRequestQuestionFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRequestQuestionFile(params: {
    requestId: string;
    questionId: string;
    fileName: string;
  },
  context?: HttpContext

): Observable<string> {

    return this.getRequestQuestionFile$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation generateRequestQuestionFileAccessUrl
   */
  static readonly GenerateRequestQuestionFileAccessUrlPath = '/v1/files/supplier-request/{requestId}/{questionId}/files/{fileName}/download-url';

  /**
   * Generate Signed url for request file scoped to a question.
   *
   * Falls back to the legacy requestId/filename path for files uploaded before the question-scoped storage path was introduced.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateRequestQuestionFileAccessUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateRequestQuestionFileAccessUrl$Response(params: {
    requestId: string;
    questionId: string;
    fileName: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, FilesV1Service.GenerateRequestQuestionFileAccessUrlPath, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.path('questionId', params.questionId, {});
      rb.path('fileName', params.fileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Generate Signed url for request file scoped to a question.
   *
   * Falls back to the legacy requestId/filename path for files uploaded before the question-scoped storage path was introduced.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `generateRequestQuestionFileAccessUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  generateRequestQuestionFileAccessUrl(params: {
    requestId: string;
    questionId: string;
    fileName: string;
  },
  context?: HttpContext

): Observable<string> {

    return this.generateRequestQuestionFileAccessUrl$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation getRequestFile
   */
  static readonly GetRequestFilePath = '/v1/files/supplier-request/{requestId}/files/{fileName}';

  /**
   * Download request case file.
   *
   * Deprecated - use the question-scoped download endpoint instead.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRequestFile()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getRequestFile$Response(params: {
    requestId: string;
    fileName: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, FilesV1Service.GetRequestFilePath, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.path('fileName', params.fileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Download request case file.
   *
   * Deprecated - use the question-scoped download endpoint instead.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRequestFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  getRequestFile(params: {
    requestId: string;
    fileName: string;
  },
  context?: HttpContext

): Observable<string> {

    return this.getRequestFile$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation generateRequestFileAccessUrl
   */
  static readonly GenerateRequestFileAccessUrlPath = '/v1/files/supplier-request/{requestId}/files/{fileName}/download-url';

  /**
   * Generate Signed url for request file.
   *
   * Deprecated - use the question-scoped download-url endpoint instead.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateRequestFileAccessUrl()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  generateRequestFileAccessUrl$Response(params: {
    requestId: string;
    fileName: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, FilesV1Service.GenerateRequestFileAccessUrlPath, 'get');
    if (params) {
      rb.path('requestId', params.requestId, {});
      rb.path('fileName', params.fileName, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * Generate Signed url for request file.
   *
   * Deprecated - use the question-scoped download-url endpoint instead.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `generateRequestFileAccessUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   *
   * @deprecated
   */
  generateRequestFileAccessUrl(params: {
    requestId: string;
    fileName: string;
  },
  context?: HttpContext

): Observable<string> {

    return this.generateRequestFileAccessUrl$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
